export enum BranchStatus {
  ACTIVE = 'ACTIVE',
  PASSIVE = 'PASSIVE',
  PENDING = 'PENDING',
  DELETED = 'DELETED'
}
